// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607080504/js/" + chunkId + "." + {"44":"08a946f4","225":"23f3c029","481":"35a03354","486":"e243fcbf","770":"d314bdd4"}[chunkId] + ".0.8294647214151071.chunk.js";
};